import { fuzzy } from "fast-fuzzy";
import { GAME_SETTINGS } from "app/data/game-settings";

export default function getWordCorrectness(
  playerSpelling: string,
  correctSpelling: string
): number {
  const numMatchingChars = getNumMatchingChars(playerSpelling, correctSpelling);
  if (numMatchingChars < correctSpelling.length * (1 - GAME_SETTINGS.wrongCharsCutoff)) {
    return 0;
  }

  return fuzzy(correctSpelling, playerSpelling, {
    threshold: 0,
    useSellers: false,
  });
}

function getNumMatchingChars(
  playerWord: string,
  correctWord: string,
  maxPositionDistance: number = 1
): number {
  let matches = 0;
  const usedIndices = new Set<number>();

  for (let i = 0; i < playerWord.length; i++) {
    const char = playerWord[i];
    
    for (let j = 0; j < correctWord.length; j++) {
      if (
        correctWord[j] === char &&
        !usedIndices.has(j) &&
        Math.abs(i - j) <= maxPositionDistance
      ) {
        matches++;
        usedIndices.add(j);
        break;
      }
    }
  }

  return matches;
}
